/*
 * HomeHero — the homepage-only banner above the question feed.
 * Real numbers only: totalQuestions/categoryCount come from the same data
 * the rest of the homepage already fetches, never hardcoded.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { CategoryInfo } from '@/services/client/quiz';
import { Icon } from '@/components';
import { BR_PREFIX, getRegion } from '@/utils/region';
import TrendingCategories from '../TrendingCategories';

import './index.scss';

interface Props {
  totalQuestions: number;
  categoryCount: number;
  categories: CategoryInfo[];
}

const HomeHero: FC<Props> = ({ totalQuestions, categoryCount, categories }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'home_hero' });

  return (
    <div className="home-hero mb-4">
      <div className="home-hero__main">
        <h1 className="home-hero__title">{t('title')}</h1>
        <p className="home-hero__subtitle">{t('subtitle')}</p>
        {/* Portuguese for the reader it is meant for, whatever this side's
          language: a visible link, never an automatic redirect. */}
        {getRegion() === 'intl' && /^pt/i.test(navigator.language) && (
          <p>
            <a href={`${BR_PREFIX}/`} className="fw-semibold">
              Estudando para concursos ou ENEM? Acesse os simulados do Brasil →
            </a>
          </p>
        )}
        <div className="home-hero__stats">
          <div className="home-hero__stat">
            <span className="home-hero__stat-num">{totalQuestions}</span>
            <span className="home-hero__stat-label">{t('stat_questions')}</span>
          </div>
          <div className="home-hero__stat">
            <span className="home-hero__stat-num">{categoryCount}</span>
            <span className="home-hero__stat-label">
              {t('stat_categories')}
            </span>
          </div>
          <div className="home-hero__stat">
            <span className="home-hero__stat-num">2</span>
            <span className="home-hero__stat-label">{t('stat_languages')}</span>
          </div>
        </div>
        <a
          className="home-hero__app"
          href="https://play.google.com/store/apps/details?id=com.aiforu2.app"
          target="_blank"
          rel="noopener noreferrer">
          <Icon name="google-play" />
          {t('get_app')}
        </a>
      </div>
      <TrendingCategories categories={categories} />
    </div>
  );
};

export default HomeHero;
